export const signInMethodKey = (sessionId: string) => `dm:signin:method:${sessionId}`;

export const rememberTicketSignIn = (sessionId: string | null) => {
  if (!sessionId) return;
  try {
    window.sessionStorage.setItem(signInMethodKey(sessionId), 'ticket');
  } catch {
    // Storage restrictions must not interrupt authentication.
  }
};
